import { StateCreator } from 'zustand'

import { wwtTutorialLog } from '../logger/wwtTutorialLog.ts'
import { TutorialStatus } from '../types/TutorialStatus.ts'

export interface TutorialState {
	stepIndex: number | null
	tutorialStatus: TutorialStatus | null
}

export interface TutorialActions {
	incrementStep: (incrementCount?: number) => void
	setTutorialStatus: (status: TutorialStatus) => void
	reset: () => void
}

export type TutorialStore = TutorialState & TutorialActions

export const tutorialStorePrototype: StateCreator<
	TutorialStore,
	[['zustand/persist', unknown], ['zustand/immer', never]],
	[]
> = set => ({
	stepIndex: null,
	tutorialStatus: null,

	incrementStep: (incrementCount = 1) => {
		set(state => {
			wwtTutorialLog('Increment step')

			if (state.tutorialStatus !== TutorialStatus.GOING) {
				throw new Error('Call incrementCount step with not GOING tutorial')
			}

			if (state.stepIndex === null) {
				state.stepIndex = 0
				return
			}

			const newStepIndex =
				state.stepIndex >= 6 ? 0 : state.stepIndex + incrementCount

			wwtTutorialLog('New step index = ', newStepIndex)
			state.stepIndex = newStepIndex
		})
	},
	setTutorialStatus: async (status: TutorialStatus) => {
		set(state => {
			wwtTutorialLog('Set tutorial status', status)
			state.tutorialStatus = status

			if (
				state.tutorialStatus === TutorialStatus.GOING &&
				state.stepIndex === null
			) {
				wwtTutorialLog(
					'Set tutorial stepIndex to 0 after change tutorialStatus'
				)
				state.stepIndex = 0
			}
		})
	},
	reset: async () => {
		set(state => {
			wwtTutorialLog('Reset tutorial state')

			state.tutorialStatus = null
			state.stepIndex = null
		})
	}
})
